import { BaseConfig } from './base-config.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Http, ResponseContentType, Headers, RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from '../shared/constantes/global';
import { ErrorService } from './error.service';
import { AslibLoadingService } from '@aslib/loading';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { ExportTypes } from '../shared/enum/shared.enum';

/**
 * @Injectable()
 * GenericHttpService
 * (ciclo angular)
 */
@Injectable()
export class GenericHttpService {
  private host: string;
  private readonly uri: string;
  private readonly application_pdf = 'application/pdf';
  private readonly application_excel = 'application/vnd.ms-excel';
  private readonly application_zip = 'application/zip';

  private readonly _headers: HttpHeaders = new HttpHeaders().append(
    Global.CONTENT_TYPE,
    Global.APPLICATION_TYPE_JSON,
  );

  private readonly genericHeaders: { [name: string]: string }[] = [];

  public headers: HttpHeaders;

  /**
   * constructor
   * GenericHttpService
   * (ciclo angular)
   */
  constructor(
    public router: Router,
    private readonly httpClient: HttpClient,
    public errorService: ErrorService,
    private readonly aslibLoadingService: AslibLoadingService,
    private readonly _baseConfig: BaseConfig,
    private readonly http: Http
  ) {
    this.headers = new HttpHeaders().append(
      Global.CONTENT_TYPE,
      Global.APPLICATION_TYPE_JSON
    );


  }

  /**
   * get
   * recupera item
   * banco de dados
   * @param url
   */
  public get<T>(url: string, api: string) {
    this.host = this._baseConfig.getUrl(api);
    return this.httpClient.get<T>(`${this.host}${url}`, {
      headers: this.headers
    });
  }

  /**
   * post<T>
   * adiciona e executa item
   * banco de dados
   * @param url
   * @param body
   */
  public post<T>(url: string, body: any[], api: string) {
    this.host = this._baseConfig.getUrl(api);
    return this.httpClient.post<T>(`${this.host}${url}`, body, { headers: this.headers });
  }

  public handleResponseTBlob = (response: any) => {
    return new Blob([response.blob], { type: this.application_pdf });
  }

  public handleError = (error: HttpErrorResponse) => {
    this.aslibLoadingService.complete();

    if (error.status === 520) {
      return Observable.throw(error.error);
    } else {
      return Observable.throw(error);
    }
  }

  public importarArquivo<T>(url: string, form: FormData, api: string) {
    this.host = this._baseConfig.getUrl(api);
    return this.httpClient.post<T>(`${this.host}${url}`, form);
  }

  /**
   * put<T>
   * atualiza item
   * banco de dados
   * @param url
   * @param body
   */
  public put<T>(url: string, body: any, api: string) {
    this.host = this._baseConfig.getUrl(api);
    return this.httpClient.put<T>(`${this.host}${url}`, body, {
      headers: this.headers
    });
  }

  /**
   * delete
   * deletar item do
   * banco de dados
   * @param url
   */
  public delete(url: string, api: string) {
    this.host = this._baseConfig.getUrl(api);
    return this.httpClient.delete(`${this.host}${url}`);
  }

  public report(url: string, obj: any, exportType: ExportTypes, api: string): Observable<Blob> {
    let applicationType: string;

    if (exportType === ExportTypes.Excel_xls) {
      applicationType = this.application_excel;}
    else if(exportType === ExportTypes.ZIP){
      applicationType = this.application_zip;
    } else {
      applicationType = this.application_pdf;
    }

    this.host = this._baseConfig.getUrl(api);
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.Blob
    });

    return this.http.post(`${this.host}${url}`, obj, options).map(res => {
      return new Blob([res.blob()], { type: applicationType });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/generic-http.service.ts